import fontawesome from "@fortawesome/fontawesome";
import faDatabase from "@fortawesome/fontawesome-free-solid/faDatabase";
import faTags from "@fortawesome/fontawesome-free-solid/faTags";
import faLink from "@fortawesome/fontawesome-free-solid/faLink";
import faCog from "@fortawesome/fontawesome-free-solid/faCog";
import faSearch from "@fortawesome/fontawesome-free-solid/faSearch";
import faPlus from "@fortawesome/fontawesome-free-solid/faPlus";
import faMinus from "@fortawesome/fontawesome-free-solid/faMinus";
import faExternalLinkAlt from "@fortawesome/fontawesome-free-solid/faExternalLinkAlt";
import faChevronDown from "@fortawesome/fontawesome-free-solid/faChevronDown";
import faCircle from "@fortawesome/fontawesome-free-solid/faCircle";
import faMale from "@fortawesome/fontawesome-free-solid/faMale";
import faFemale from "@fortawesome/fontawesome-free-solid/faFemale";
import faDownload from "@fortawesome/fontawesome-free-solid/faDownload";
import faSpinner from "@fortawesome/fontawesome-free-solid/faSpinner";
import faPills from "@fortawesome/fontawesome-free-solid/faPills";
import faInfo from "@fortawesome/fontawesome-free-solid/faInfo";
import faShareAlt from "@fortawesome/fontawesome-free-solid/faShareAlt";

import faTwitter from "@fortawesome/fontawesome-free-brands/faTwitter";
import faFacebook from "@fortawesome/fontawesome-free-brands/faFacebook";
import faLinkedin from "@fortawesome/fontawesome-free-brands/faLinkedin";
import faBitbucket from "@fortawesome/fontawesome-free-brands/faBitbucket";
import faCreativeCommons from "@fortawesome/fontawesome-free-brands/faCreativeCommons";

import faTrashAlt from "@fortawesome/fontawesome-free-regular/faTrashAlt";
import faFileAlt from "@fortawesome/fontawesome-free-regular/faFileAlt";
import faFolderOpen from "@fortawesome/fontawesome-free-regular/faFolderOpen";
import faSignInAlt from "@fortawesome/fontawesome-free-solid/faSignInAlt";
import faSignOutAlt from "@fortawesome/fontawesome-free-solid/faSignOutAlt";
import faStar from "@fortawesome/fontawesome-free-solid/faStar";
import faUsersCog from "@fortawesome/fontawesome-free-solid/faUsersCog";

fontawesome.library.add(
  faDatabase,
  faTags,
  faLink,
  faCog,
  faSearch,
  faPlus,
  faMinus,
  faFileAlt,
  faTrashAlt,
  faExternalLinkAlt,
  faChevronDown,
  faCircle,
  faMale,
  faFemale,
  faDownload,
  faSpinner,
  faTwitter,
  faFacebook,
  faLinkedin,
  faBitbucket,
  faCreativeCommons,
  faFolderOpen,
  faSignInAlt,
  faSignOutAlt,
  faPills,
  faInfo,
  faStar,
  faUsersCog,
  faShareAlt
);



// WEBPACK FOOTER //
// ./src/include/fontawesome.js